import { md5 } from './strings'
var CryptoJS = require('crypto-js')

const FileUtils = {
    readChunked(file, chunkCallback, endCallback) {
        var fileSize = file.size
        var chunkSize = 4 * 1024 * 1024 // 4MB
        var offset = 0

        var reader = new FileReader()
        reader.onload = function () {
            if (reader.error) {
                endCallback(reader.error || {})
                return
            }
            offset += reader.result.length
            // callback for handling read chunk
            // TODO: handle errors
            chunkCallback(reader.result, offset, fileSize)
            if (offset >= fileSize) {
                endCallback(null)
                return
            }
            readNext()
        }

        reader.onerror = function (err) {
            endCallback(err || {})
        }

        function readNext() {
            var fileSlice = file.slice(offset, offset + chunkSize)
            reader.readAsBinaryString(fileSlice)
        }
        readNext()
    },

    getMD5(blob, cbProgress) {
        return new Promise((resolve, reject) => {
            var md5 = CryptoJS.algo.MD5.create()
            this.readChunked(
                blob,
                (chunk, offs, total) => {
                    md5.update(CryptoJS.enc.Latin1.parse(chunk))
                    if (cbProgress) {
                        cbProgress(offs / total)
                    }
                },
                (err) => {
                    if (err) {
                        reject(err)
                    } else {
                        // TODO: Handle errors
                        var hash = md5.finalize()
                        var hashHex = hash.toString(CryptoJS.enc.Hex)
                        resolve(hashHex)
                    }
                }
            )
        })
    },
    readFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.onabort = () => reject(new Error('Reading aborted'))
            reader.onerror = () => reject(new Error('file reading has failed'))
            reader.onload = () => {
                const arrayBuffer = reader.result
                const buffer = Buffer.from(arrayBuffer)
                resolve(buffer)
            }

            reader.readAsArrayBuffer(file)
        })
    },

    checksum(content) {
        return md5(content)
    },

    getFileExtension(filename) {
        return filename.split('.').pop()
    },

    getFileWithoutExtension(filename) {
        const withoutExtension = filename.split('.')
        withoutExtension.pop()
        return withoutExtension.join('.')
    },

    humanFileSize(size) {
        const i = Math.floor(Math.log(size) / Math.log(1024))
        return `${(size / 1024 ** i).toFixed(2)} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`
    },
}

export default FileUtils
